import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const assinaturaInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      // Se receber 403 com redirect para assinatura
      if (error.status === 403 && error.error?.redirect === '/farmacia/assinatura') {
        router.navigate(['/farmacia/assinatura']);
      }
      
      return throwError(() => error);
    })
  );
};
